import { DEFAULT_PAGINATOR } from "../constants/api";
import ClientService from "../services/client-service";

const GET_ALL = "client/GET_ALL";
const RESET_DROPDOWN = "client/RESET_DROPDOWN";
const GET_ALL_DROPDOWN = "client/GET_ALL_DROPDOWN";
const GET_BY_ID = "client/GET_BY_ID";
const UPDATE = "client/UPDATE";
const DELETE = "client/DELETE";

const initalState = {
  list: {
    data: [],
    paginator: DEFAULT_PAGINATOR,
  },
  detail: null,
  dropdown: {
    data: [],
    paginator: DEFAULT_PAGINATOR,
  }
};

const client = (state = { ...initalState }, { type, payload }) => {
  let findIdx = -1
  switch (type) {
    case GET_ALL:
      return {
        ...state,
        list: {
          data: payload.data,
          paginator: payload.paginator
        },
      };
    case GET_ALL_DROPDOWN:
      return {
        ...state,
        dropdown: {
          data: [...state.dropdown.data, ...payload.data],
          paginator: payload.paginator
        },
      };
    case GET_BY_ID:
      return {
        ...state,
        detail: payload.data
      };
    case RESET_DROPDOWN:
      return {
        ...state,
        dropdown: {
          data: [],
          paginator: DEFAULT_PAGINATOR
        }
      };
    case UPDATE:
      if (state.detail && state.detail.id === payload.data.id) {
        state.detail = {
          ...state.detail,
          ...payload.data,
        }
      }
      findIdx = state.list.data.findIndex(d => d.id === payload.data.id)
      if (findIdx > -1) {
        state.list.data[findIdx] = {
          ...state.list.data[findIdx],
          ...payload.data
        }
      }
      findIdx = state.dropdown.data.findIndex(d => d.id === payload.data.id)
      if (findIdx > -1) {
        state.dropdown.data[findIdx] = {
          ...state.dropdown.data[findIdx],
          ...payload.data
        }
      }
      return {
        ...state,
      };
    case DELETE:
      if (state.detail && state.detail.id === payload.data.id) {
        state.detail = null
      }
      findIdx = state.list.data.findIndex(d => d.id === payload.data.id)
      if (findIdx > -1) {
        state.list.data.splice(findIdx, 1)
        state.list.paginator = {
          ...state.list.paginator,
          totalItems: state.list.paginator.totalItems - 1,
          itemTo: state.list.paginator.itemTo - 1,
        }
      }
      findIdx = state.dropdown.data.findIndex(d => d.id === payload.data.id)
      if (findIdx > -1) {
        state.dropdown.data.splice(findIdx, 1)
        state.dropdown.paginator = {
          ...state.dropdown.paginator,
          totalItems: state.dropdown.paginator.totalItems - 1,
          itemTo: state.dropdown.paginator.itemTo - 1,
        }
      }
      return {
        ...state,
      };
    default:
      return state;
  }
};
export default client;

export const getAll = (params, isDropdown = false) => async (dispatch) => {
  const resp = await ClientService.getAll(params);
  if (resp.status && resp.status === 200) {
    if (isDropdown) {
      dispatch({ type: GET_ALL_DROPDOWN, payload: resp.data });
    } else {
      dispatch({ type: GET_ALL, payload: resp.data });
    }
  }
  return resp
};

export const getByIdDropdown = async (id) => {
  const resp = await ClientService.getById(id);
  if (resp.status && resp.status === 200) {
    return resp.data.data
  }
  return null
};

export const getById = (id) => async (dispatch) => {
  const resp = await ClientService.getById(id);
  if (resp.status && resp.status === 200) {
    dispatch({ type: GET_BY_ID, payload: resp.data });
  }
  return resp
};

export const resetDropdown = () => async (dispatch) => {
  dispatch({ type: RESET_DROPDOWN });
};

export const updateById = (id, params) => async (dispatch) => {
  const resp = await ClientService.updateById(id, params);
  if (resp.status && resp.status === 200) {
    dispatch({ type: UPDATE, payload: resp.data });
  }
  return resp
};

export const create = (params) => {
  return ClientService.create(params);
};

export const deleteById = (id) => async (dispatch) => {
  const resp = await ClientService.deleteById(id);
  if (resp.status && resp.status === 200) {
    dispatch({ type: DELETE, payload: resp.data });
  }
  return resp
};